import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DownloadFileService {
  downloadFile(fileOrUrl: BlobPart | string, filename: string, mimeType: string): void {
    let url: string;
    if (typeof fileOrUrl === 'string') {
      url = fileOrUrl;
    } else {
      const blob: Blob = new Blob([fileOrUrl], { type: mimeType });
      url = URL.createObjectURL(blob);
    }

    const anchor: HTMLAnchorElement = document.createElement('a');
    anchor.style.display = 'none';
    anchor.download = filename;
    anchor.href = url;
    document.body.appendChild(anchor);
    anchor.click();
    setTimeout(() => {
      document.body.removeChild(anchor);
      if (typeof fileOrUrl !== 'string') {
        URL.revokeObjectURL(url);
      }
    }, 200);
  }
}
